module.exports = __webpack_public_path__ + "img/ch39.d5d67c56.jpg";